import { axiosInstance } from '../../../shared/api';

export async function listStatementImports(status = 'pending') {
	const response = await axiosInstance.get(`statement-imports`, {
		params: { status },
	});
	return response.data;
}

export async function getStatementImport(importId) {
	const response = await axiosInstance.get(`statement-imports/${importId}`, {
		withCredentials: true,
	});
	return response.data;
}

export async function uploadStatement(file, outputLanguage = 'original') {
	const formData = new FormData();
	formData.append('file', file);
	formData.append('output_language', outputLanguage);

	const response = await axiosInstance.post('statement-imports', formData, {
		timeout: 180000,
		headers: { 'Content-Type': 'multipart/form-data' },
	});
	return response.data;
}

export async function updateStatementTransaction(importId, txId, data) {
	const response = await axiosInstance.patch(
		`statement-imports/${importId}/transactions/${txId}`,
		data,
		{},
	);
	return response.data;
}

export async function deleteStatementTransaction(importId, txId) {
	await axiosInstance.delete(
		`statement-imports/${importId}/transactions/${txId}`,
	);
}

export async function commitStatementImport(importId) {
	const response = await axiosInstance.post(
		`statement-imports/${importId}/commit`,
	);
	return response.data;
}

export async function cancelStatementImport(importId) {
	const response = await axiosInstance.delete(`statement-imports/${importId}`);
	return response.data;
}
